import { api } from "./apiClient";

export const supervisorAPI = {
  dashboard: (projectId) =>
    api.get(`/projects/${projectId}/supervisor/dashboard`),

  operationsDashboard: (projectId) =>
    api.get(`/projects/${projectId}/operations/dashboard`, {
      timeout: 120000,
    }),

  operationsManagementReport: (projectId) =>
    api.get(`/projects/${projectId}/operations/management-report.xlsx`, {
      responseType: "blob",
    }),

  supervisorPerformanceReport: (projectId) =>
    api.get(`/projects/${projectId}/supervisor/performance-report.xlsx`, {
      responseType: "blob",
    }),

  listForemanFindings: (projectId) =>
    api.get(`/projects/${projectId}/supervisor/foreman-findings`),

  listForemanAssignedInspections: (projectId) =>
    api.get(`/projects/${projectId}/supervisor/foreman-assigned-inspections`),

  reassignFinding: (projectId, findingId, payload) =>
    api.patch(
      `/projects/${projectId}/supervisor/findings/${findingId}/reassign`,
      payload,
    ),

  reviewFindingAsGeneralForeman: (projectId, findingId, payload) =>
    api.patch(
      `/projects/${projectId}/general-foreman/findings/${findingId}/review`,
      payload,
    ),
};
